import classNames from 'classnames';
import { FunctionComponent, PropsWithChildren } from 'react';

type DetailsFormHighlightProps = PropsWithChildren<{
    disabled: boolean;
}>;

export const DetailsFormHighlight: FunctionComponent<DetailsFormHighlightProps> = ({ disabled, children }) => {
    return (
        <div
            className={classNames('border rounded display-grid grid-cols-2 padding-15 column-gap-15 row-gap-0', {
                'border-color-primary': !disabled,
                'bg-highlight-lightest': !disabled,
                'border-color-gray': disabled,
                'bg-lightest': disabled,
            })}
        >
            {children}
        </div>
    );
};
